import React from 'react';

interface WizardProgressProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: string[];
}

const WizardProgress: React.FC<WizardProgressProps> = ({ currentStep, totalSteps, stepLabels }) => {
  return (
    <div className="wizard-progress">
      {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
        <div key={step} className={`progress-step ${step <= currentStep ? 'active' : ''}`}>
          <div className="step-number">{step}</div>
          <div className="step-label">
            {stepLabels[step - 1]}
          </div>
        </div>
      ))}
    </div>
  );
};

export default WizardProgress;
